/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: Cognos Dashboard
 *
 * Copyright IBM Corp. 2020
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../../lib/@waca/core-client/js/core-client/ui/core/View',
	'../../../../widgets/livewidget/nls/StringResources',
	'./internal/TextInputPromptComponent',
	'react',
	'react-dom'
], function(View, StringResources, TextInputPromptComponent, React, ReactDOM) {

	/**
	 * This class renders input(s) prompt dialog and handles events in this dialog.
	 */
	class TextInputPromptDialog extends View {

		/**
		 * prop-types are defined in: {@link TextInputPromptComponent} 
		 */
		constructor(options) {
			super(options);

			this.dashboard = options.dashboard;
			this._onOk = options.onOk;
			this._onCancel = options.onCancel;
			this.name = options.name;

			const userPreferences = this.dashboard.getGlassCoreSvc('.UserProfile').preferences;
			this.props = {
				// dialog properties
				title: StringResources.get('promptTitle'),
				subTitle: this.name,
				isDirty: false,
				textDir: userPreferences && userPreferences.baseTextDirection,
				values: options.values,
				dataType: options.dataType,

				// dialog call backs
				onDone: this._onDone.bind(this),
				onClose: this._onClose.bind(this)
			};

		}

		open() {
			ReactDOM.render(
				<TextInputPromptComponent {...this.props}/>,
				this._getContainerNode()
			);
		}

		/**
		 * Applies the input value as prompt value
		 * @param {string} value
		 */
		_onDone(value) {
			this._onOk(value);
			this._close();
		}

		_onClose() {
			this._onCancel();
			this._close();
		}

		_close() {
			const containerNode = this._getContainerNode();
			if (containerNode) {
				ReactDOM.unmountComponentAtNode(containerNode);
			}
			this.$el.remove();
			this.$el = null;
			super.remove();
		}

		_getContainerNode() {
			return this.$el && this.$el[0];
		}
	}

	return TextInputPromptDialog;

});
